import React, { useContext } from 'react';
import { AccordionContext, Button, useAccordionButton } from 'react-bootstrap';
import { getTimeDateFormat } from '../../../utils/date';

function SlotHeader({ slot, eventKey }) {
	const { activeEventKey } = useContext(AccordionContext);
	const decoratedOnClick = useAccordionButton(eventKey);

	const isCurrentEventKey = activeEventKey.includes(eventKey);

	return (
		<div className="d-flex justify-content-between m-1" key={slot.id}>
			<div className="ms-2">{`${slot.start}  -  ${getTimeDateFormat(slot.end)}`}</div>
			<Button variant="link" size="sm" className="p-0 ms-3" onClick={decoratedOnClick}>
				<span className={`glyphicons glyphicons-chevron-${isCurrentEventKey ? 'up' : 'down'}`} />
			</Button>
		</div>
	);
}

export default SlotHeader;
